<template>
  <div class="reum-editor">
    <Ckeditor
      v-model="comp.content"
      :editor="comp.editor"
      :config="comp.config"
      @ready="comp.onReady"
    ></Ckeditor>
  </div>
</template>

<script>
// @ is an alias to /src
import { onMounted, reactive, watch } from "vue";
import { component as Ckeditor } from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import axios from "@/plugins/axios.js";

class CustomUploadAdapter {
  constructor(loader, etype) {
    this.loader = loader;
    this.etype = etype;
  }

  upload() {
    return this.loader.file.then(
      (file) =>
        new Promise((resolve, reject) => {
          const formData = new FormData();
          formData.append("file", file);
          formData.append("etype", this.etype);

          axios
            .post("/admin/upload", formData)
            .then((res) => {
              if (res.data.success) {
                const { uploadUrl } = res.data.data;
                resolve({
                  default: uploadUrl,
                });
              } else {
                reject(res.data.err_msg);
              }
            })
            .catch((error) => {
              reject(error);
            });
        })
    );
  }

  abort() {
    // Handle abort if needed
  }
}

function CustomUploadAdapterPlugin(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
    return new CustomUploadAdapter(loader, editor.config.get("etype"));
  };
}

export default {
  name: "BagicEditor",
  components: {
    Ckeditor,
  },
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    etype: {
      type: String,
      default: "temp",
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const comp = reactive({
      editor: ClassicEditor,
      etype: "",
      content: "",

      config: {
        etype: props.etype,
        extraPlugins: [CustomUploadAdapterPlugin],
      },

      onReady: (editor) => {
        console.log("CKEditor5 is ready", editor);
      },
    });

    watch(
      () => comp.content,
      (nVal) => {
        emit("update:modelValue", nVal);
      }
    );

    watch(
      () => props.modelValue,
      (nVal, oVal) => {
        if (nVal != oVal) {
          comp.content = nVal;
        }
      }
    );

    watch(
      () => props.etype,
      (nVal) => {
        comp.config.etype = nVal;
      }
    );

    onMounted(() => {
      comp.content = props.modelValue;
      comp.etype = props.etype;
    });

    return { comp };
  },
};
</script>
<style lang="scss">
.reum-editor {
  width: 100%;
  height: 100%;

  :deep(.ck.ck-editor__editable[role='textbox']) {
    min-height: 500px;
  }
}
</style>
